import React, { JSX } from 'react'

const HamburgerIcon: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="3.5" y="7" width="16" height="1" fill={props.fill || '#fff'} />
    <rect x="3.5" y="16" width="16" height="1" fill={props.fill || '#fff'} />
  </svg>
)

export default HamburgerIcon
